import { CheckoutDraughtDutyOption } from "./types";

export const mapToDraughtRequirements = (
  draughtDutyOption: CheckoutDraughtDutyOption,
) => {
  switch (draughtDutyOption) {
    case "yes":
      return "Yes I'm going to sell some of these keg/cask products for take-away";
    case "no":
      return "No, I'm NOT going to sell any of these keg/cask products for take-away";
    default:
      return "Not set";
  }
};
